<div>
  <h1>Confirmar</h1>
  <p>Há uma renegociação pendente, deseja realmente iniciar outra?</p>
  <div class="actions">
    <button mat-button (click)="dialogRef.close()">Cancelar</button>
    <button 
      mat-raised-button 
      autofocus 
      (click)="confirmar()" 
      data-context="renegociacao" 
      data-collect="exclusao do acordo"
      color="primary">
      Confirmar
    </button>
  </div>
</div>
